module.exports = __webpack_public_path__ + "img/resources-1920.8243d395.jpg";